import gql from 'graphql-tag';

const query = gql`
  query LoginBySocialMediaQuery {
    me {
      id
      isAbleToLoginWithFacebook
      isAbleToLoginWithGoogle
      isAbleToLoginWithApple
    }
  }
`;

export default query;
